"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _reflectiveBind = _interopRequireDefault(require("./reflectiveBind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The babel transform will turn any calls to x.bind(...args) to
 * babelBind(x, ...args). If x is a function, we want to do a reflective bind,
 * otherwise we want to "revert" it back to the previous x.bind(...args) call.
 */
function _default(x
/*: any*/
) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (typeof x === "function" && x.bind === Function.prototype.bind) {
    return _reflectiveBind.default.apply(void 0, [x].concat(args));
  } else {
    return x.bind.apply(x, args);
  }
}